export default __webpack_public_path__ + "static/media/a009-2.6d1c7d51.svg";